'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getCountries;

var _getCountries = require('./getCountries');

var _getCountries2 = _interopRequireDefault(_getCountries);

var _metadataMin = require('libphonenumber-js/metadata.min.json');

var _metadataMin2 = _interopRequireDefault(_metadataMin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCountries() {
	return (0, _getCountries2.default)(_metadataMin2.default);
}
//# sourceMappingURL=getCountriesDefaultMetadata.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/modules/libphonenumber/getCountriesDefaultMetadata.js
// module id = 701
// module chunks = 2